import { t as require_buffer } from "./chunk-buffer.mjs";
import { process } from "./process.mjs";
//#region src/globals.js
var import_buffer = require_buffer();
(() => {
	if (typeof globalThis !== "undefined" && !Object.getOwnPropertyDescriptor(globalThis, "global")) Object.defineProperty(globalThis, "global", {
		value: globalThis,
		configurable: true,
		writable: false,
		enumerable: true
	});
	if (typeof globalThis !== "undefined" && !globalThis.Buffer) globalThis.Buffer = import_buffer.Buffer;
	if (typeof globalThis !== "undefined" && !globalThis.process) globalThis.process = process;
})();
//#endregion

//# sourceMappingURL=globals.mjs.map